import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectVehicle } from '../../../Vehicles/selectors';
import { selectWork } from '../../../Api/selectors';
import { REQUEST_VEHICLE } from '../../../Vehicles/constants';
import { fetchVehicle } from '../../../Vehicles/actions';
import { Loader } from '../../../../components/Loader';
import { fetchVehiclePurchaseInvoiceDocument } from '../../../Documents/actions';
import { REQUEST_VEHICLE_INVOICE_DOCUMENT } from '../../../Users/constants';

const STATE = {
  email: false,
};
/* eslint-disable react/prefer-stateless-function */
class PdfViewerCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.fetch(this.props.vehicleId);
  }

  componentDidUpdate() {
    if (!this.state.vehicleDocs) {
      this.props.fetch(this.props.vehicleId, result => {
        if (result?.id) {
          this.setState({ vehicleDocs: result?.documents });
        }
      });
    }
    this.getPdfUrl();
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get invoicePurchaseDoc() {
    return this.vehicle?.documents?.filter(doc => doc?.originalFilename == 'invoice_purchase');
  }

  getPdfUrl() {
    if (!this.invoicePurchaseDoc?.length || this.state.objectUrl) return;
    this.props.fetchDoc(this.invoicePurchaseDoc[0]?.id, result => {
      var blob = new Blob([new Uint8Array(result.file.data)], { type: 'application/pdf' });
      var objectUrl = URL.createObjectURL(blob);
      this.setState({ objectUrl: objectUrl });
    });
  }

  render() {
    if (this.props.work) return <Loader small />;

    if (this.props.downloading) return <Loader />;
    return (
      <embed
        style={!this.state.objectUrl ? { display: 'none' } : { width: '100%', height: '68vw' }}
        toolbar="lightbox"
        type="application/pdf"
        id={'iframeid'}
        sandbox="allow-top-navigation"
        src={this.state.objectUrl}
      ></embed>
    );
  }
}

PdfViewerCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    downloading: selectWork(REQUEST_VEHICLE_INVOICE_DOCUMENT),
    vehicle: selectVehicle(ownProps.vehicleId),
    work: selectWork(REQUEST_VEHICLE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(id, callback) {
      dispatch(fetchVehicle(id, callback));
    },
    fetchDoc(documentId, callback) {
      dispatch(fetchVehiclePurchaseInvoiceDocument(documentId, callback));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const PdfViewerCard = compose(
  withConnect,
  withRouter,
)(PdfViewerCardComp);
